import * as Sentry from '@sentry/remix';
/**
 * By default, Remix will handle hydrating your app on the client for you.
 * You are free to delete this file if you'd like to, but if you ever want it revealed again, you can run `npx remix reveal` ✨
 * For more information, see https://remix.run/file-conventions/entry.client
 */

import {RemixBrowser, useLocation, useMatches} from '@remix-run/react';
import {StrictMode, startTransition, useEffect} from 'react';
import {hydrateRoot} from 'react-dom/client';

Sentry.init({
  enabled: import.meta.env.MODE !== 'development',
  dsn: 'https://d49cd9874ffc0a05b862e6aaec2d7c9e@o4506796474499072.ingest.us.sentry.io/4507498592468992',
  tracesSampleRate: 1,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
  sampleRate: 1,
  environment: import.meta.env.MODE,
  integrations: [
    Sentry.browserTracingIntegration({
      useEffect,
      useLocation,
      useMatches,
    }),
  ],
});

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <RemixBrowser />
    </StrictMode>,
  );
});
